import {some} from 'lodash';

export default {
  projectsListState(state) {
    return state.projectsList;
  },
  projectsErrorListState(state) {
    return state.projectsErrorList;
  },
  projectsHasErrorsListState(state) {
    return state.projectsErrorList.map(item => {
      return some(Object.values(item));
    });
  },
  projectsHasValuesState(state) {
    return state.projectsList
      .map(item => {
        return some(Object.values(item));
      })
      .includes(true);
  }
};
